import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { ToasterService } from '@mars/ui-components';
import { AuthService } from '../services/auth/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const toastService = inject(ToasterService);

  const handleLoggingOut = (errorMessage: string) => {
    toastService.add('', errorMessage, 'assets/icons/danger.svg', 'error');
    authService.logoutAction();
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handle = (status: number, error: any): Observable<never> => {
    if (status == 401 || status == 500) {
      handleLoggingOut(error.message);
    } else if (status == 403) {
      toastService.add('', error.message, 'assets/icons/danger.svg', 'error');
    } else if (status != 422) {
      toastService.add(
        '',
        error.message,
        'assets/icons/danger.svg',
        'error',
        true,
        false
      );
    }
    return throwError(() => error);
  };

  return next(req).pipe(
    catchError((httpError: HttpErrorResponse) =>
      // A file request (`responseType: 'blob'`) gets its JSON error as a
      // Blob: read it first, so the message is the backend's.
      httpError.error instanceof Blob
        ? from(readText(httpError.error)).pipe(
            switchMap(text => handle(httpError.status, parseJson(text)))
          )
        : handle(httpError.status, httpError.error)
    )
  );
};

/** A Blob's text, through FileReader so it also runs where `Blob.text` doesn't. */
function readText(blob: Blob): Promise<string> {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ''));
    reader.onerror = () => resolve('');
    reader.readAsText(blob);
  });
}

function parseJson(text: string): object {
  try {
    return JSON.parse(text);
  } catch {
    return {};
  }
}
